// ** React Imports
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import {  useHistory } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils

// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { handleLogout } from '@store/authentication'

// ** Third Party Components
import { User, Mail, CheckSquare, MessageSquare, Settings, CreditCard, HelpCircle, Power } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import {Cookies} from 'react-cookie'
// ** Default Avatar Image
import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import { logout } from '../../../../requests/auth'


const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch()

  // ** State
  //const [userData, setUserData] = useState(null)

  const cookies=new Cookies();
  const history = useHistory()
  //** ComponentDidMount
  // useEffect(() => {
  //   if (isUserLoggedIn() !== null) {
  //     setUserData(JSON.parse(localStorage.getItem('userData')))
  //   }
  // }, [])
  const HandleLogout= ()=>{
    const tokenName= process.env.REACT_APP_TOKEN_NAME || "back_office_t";
    const refreshTokenName= process.env.REACT_APP_REFRESH_TOKEN_NAME || "back_office_refresh";
    const refreshToken=cookies.get(refreshTokenName, {path:'/'});
    logout(refreshToken)
    .then(()=>{})
    .catch((err)=>{
      console.log("err",err);
    })
   .finally(()=>{
      cookies.remove(tokenName,{path:'/'});
      cookies.remove(refreshTokenName,{path:'/'});
      dispatch(handleLogout())
    // ability.update(res.data.userData.ability)
      history.push('/login')
    })
    
  }
  const userData= useSelector(state => state.auth?.userData);
  //** Vars
  const userAvatar = (userData && userData.avatar) || defaultAvatar

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{userData?.firstName}{" "}{userData?.lastName}</span>
          <span className='user-status'>{userData?.email}</span>
        </div>
        <Avatar img={userAvatar} imgHeight='40' imgWidth='40'  />
        {/* status='online' */}
      </DropdownToggle>
      <DropdownMenu end>
        {/* <DropdownItem tag={Link} to='/pages/profile'>
          <User size={14} className='me-75' />
          <span className='align-middle'>Profile</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/email'>
          <Mail size={14} className='me-75' />
          <span className='align-middle'>Inbox</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/todo'>
          <CheckSquare size={14} className='me-75' />
          <span className='align-middle'>Tasks</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/apps/chat'>
          <MessageSquare size={14} className='me-75' />
          <span className='align-middle'>Chats</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem tag={Link} to='/pages/account-settings'>
          <Settings size={14} className='me-75' />
          <span className='align-middle'>Settings</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/pages/pricing'>
          <CreditCard size={14} className='me-75' />
          <span className='align-middle'>Pricing</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/pages/faq'>
          <HelpCircle size={14} className='me-75' />
          <span className='align-middle'>FAQ</span>
        </DropdownItem> */}
        <DropdownItem tag={Link} to='/login' onClick={HandleLogout}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
